import {ISVG} from "../../common/Logo/Logo";

export interface IShape2Props extends Pick<ISVG, "fill"> {}

export const Shape2 = ({ fill }: IShape2Props) => {
    const _fill = fill ?? "white";

    return (
        <svg
            width="433"
            height="100"
            viewBox="0 0 433 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M253.217 -294.332C313.705 -309.143 376.937 -389.769 422.176 -348.235C465.516 -308.445 364.858 -251.613 362.629 -193.882C358.783 -94.2815 487.345 26.8402 405.359 87.3061C328.523 143.974 253.793 -4.67712 170.631 -52.2805C103.898 -90.4796 -20.4091 -82.3708 -21.9831 -157.312C-23.6188 -235.186 94.0872 -249.769 165.734 -285.441C193.158 -299.095 223.313 -287.01 253.217 -294.332Z"
                fill={_fill}
            />
        </svg>
    );
};
